<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="contingente?.desde" 
            [DateEnd]="contingente?.hasta"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="contingenteHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [enableCut]=false
            [CurrentPeriod]="contingente?.id">
</iboxtools>

<app-contingentes-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                         [contingentes]="contingentes" 
                                                         [permisoEdicion]="permisoEdicion"
                                                         (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-contingentes-list>

<app-contingentes-detalle #ChildContingenteDetalle [contingente]="contingente" *ngIf="verDetalle" 
                          [enabledForm]="habilitarFormDetalle" 
                          [MensajeError]="MensajeError" 
                          [desdeAnterior]="desdeAnterior" 
                          [ingreso]="ingreso"
                          [anteriorRetroactividad]="anteriorRetroactividad" 
                          [grupoLiq]="gruposLiquidaciones" 
                          [contingentesInvalida]="contingentesInvalida">
</app-contingentes-detalle>

